import { render, staticRenderFns } from "./charts4.vue?vue&type=template&id=003bb521&"
import script from "./charts4.vue?vue&type=script&lang=js&"
export * from "./charts4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports